"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptor = exports.cmdExecute = exports.isSafeOrigin = void 0;
const core_1 = require("../core");
const private_1 = require("../utils/private");
const event_message_1 = require("./event_message");
const protocol_1 = require("./protocol");
const widget_message_1 = require("./widget_message");
/**
 * Is it a secure domain name.
 * 1. Main application with the same domain name.
 * 2. localhost Local debugging domain name.
 */
const isSafeOrigin = (origin) => {
    const SAFE_ORIGIN_END = [window.location.origin];
    const LOCAL = ['https://localhost', 'http://localhost'];
    return SAFE_ORIGIN_END.some(str => origin.endsWith(str)) || LOCAL.some(str => origin.startsWith(str));
};
exports.isSafeOrigin = isSafeOrigin;
const cmdExecute = (cmdOptions, widgetId) => {
    if ((0, private_1.isSandbox)()) {
        return widget_message_1.widgetMessage.syncCmd(cmdOptions);
    }
    if (!widgetId) {
        return new Promise((resolve) => resolve({
            result: core_1.ExecuteResult.None,
            resourceId: '',
            resourceType: core_1.ResourceType.Widget
        }));
    }
    return event_message_1.eventMessage.syncCmd(cmdOptions, widgetId);
};
exports.cmdExecute = cmdExecute;
/**
 * Receiving Message Interceptor.
 * @param res
 * @param callback
 */
const interceptor = (callback) => {
    return (res, messageId) => {
        if (!res.success) {
            console.error(res.message);
            return;
        }
        callback === null || callback === void 0 ? void 0 : callback(res.data, messageId);
        messageId && protocol_1.messageMap.pop(messageId, {
            success: true,
            data: res.data
        });
    };
};
exports.interceptor = interceptor;
